import MuiChip from '@mui/material/Chip';
import clsx from 'clsx';

import { useChipVariantStyles } from './config';
import { CustomChipProps } from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const CustomChip: React.FC<CustomChipProps> = (props) => {
  const { sx, skin, color, rounded, ...restProps } = props;

  // =============== HOOKS
  const colors = useChipVariantStyles();

  // =============== VIEWS
  return (
    <MuiChip
      color={color}
      {...restProps}
      variant="filled"
      className={clsx({
        'MuiChip-rounded': rounded,
        'MuiChip-light': skin === 'light',
      })}
      sx={skin === 'light' && color ? Object.assign(colors[color], sx) : sx}
    />
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './props';
export default CustomChip;
